import { render } from "./TertiaryInsurance.vue?vue&type=template&id=68c9da4f"
import script from "./TertiaryInsurance.vue?vue&type=script&lang=js"
export * from "./TertiaryInsurance.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pendingCases/billingInfo/forms/TertiaryInsurance.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "68c9da4f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('68c9da4f', __exports__)) {
    console.log('reload')
    api.reload('68c9da4f', __exports__)
  }
  
  module.hot.accept("./TertiaryInsurance.vue?vue&type=template&id=68c9da4f", () => {
    console.log('re-render')
    api.rerender('68c9da4f', render)
  })

}


export default __exports__